<template>
  <div class="meizu">
    <div class="header">
      <p>{{ app.header.tip1 }}</p>
    </div>
    <div class="container">
      <div class="container-title">
        <div class="num">1</div>
        <div class="title-word">{{ app.content.list1.title }}</div>
      </div>
      <div class="content">
        <img src="../assets/meizu-1.png" alt="" />
        <img src="../assets/meizu-2.png" alt="" />
        <img src="../assets/meizu-3.png" alt="" />
      </div>
      <div class="container-title">
        <div class="num">2</div>
        <div class="title-word">
          <p>{{ app.content.list2.title1 }}</p>
          <p>{{ app.content.list2.title2 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zh from "@/locales/meizu/zh";
import en from "@/locales/meizu/en";
import { toggleLang } from "@/mixins/toggleLang";
export default {
  name: "meizu",
  mixins: [toggleLang],
  created() {
    this.toggle(zh, en);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.meizu {
  color: #000;
}
</style>
